// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"336":"61ced5f7","615":"63c75990","709":"63c75990","872":"63c75990","884":"fa5f16e2"}[chunkId] + ".css";
};